import React from 'react';
import Flexbox from 'flexbox-react';
import { observer, Provider } from 'mobx-react';
import AppStore from '../stores/AppStore';
import ToastStore from '../stores/ToastStore';
import CurrentUserStore from '../stores/CurrentUserStore';
import ThemeWrapper from '../components/styles/ThemeWrapper/index.js';
import NewOrganisationRelationShip from '../components/organization/NewOrganisationRelationShip';
import ErrorBoundary from '../components/errors/ErrorBoundary';

@observer
export default class NewOrganisationView extends React.Component {
  render() {
    const stores = {
      AppStore,
      CurrentUserStore,
      ToastStore,
    };

    return (
      <Provider {...stores}>
        <ThemeWrapper>
          <ErrorBoundary>
            <Flexbox flexGrow={1} width="100hw" alignContent="stretch" flexDirection="column" paddingBottom="0px">
              <Flexbox flexGrow={1} flexDirection="column" className="fixed-width-container" marginTop="20px">
                <Flexbox marginBottom="10px">
                  <h2 className="bp3-heading">{I18n.t('js.new_organisation')}</h2>
                </Flexbox>
                <div className="page-subtitle" style={{ marginBottom: '12px' }}>
                  <p style={{ margin: 0, color: '#6b7280', fontSize: '14px' }}>View and manage your company's reporting hierarchy — see who reports to whom across teams.</p>
                </div>
                <Flexbox flexDirection="column" flexGrow={1} marginTop="10px" className="chart-area bp3-card">
                  <NewOrganisationRelationShip currentUser={CurrentUserStore.currentUser} />
                </Flexbox>
              </Flexbox>
            </Flexbox>
          </ErrorBoundary>
        </ThemeWrapper>
      </Provider>
    );
  }
}
